import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import RemoveOrgModal from '../components/RemoveOrgModal';
import OrgSettingsStore from '../stores/org-settings-store';
import { deleteOrganization } from '../actions/org-settings-actions';
import { useAuth0 } from '@auth0/auth0-react';
import isEmpty from 'lodash/isEmpty';
import { useOrganizations } from '../../organizations/api/organizations-api';
import {
  setRemoveOrgModalVisibility,
  setRemoveOrgVerificationValue,
  setSettingErrorMessage,
} from '../store-actions/org-settings-store-actions';

const RemoveOrgContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    isRemoveOrgModalVisible,
    isLoadingRemoveOrg,
    removeOrgVerificationValue,
    errorMessage,
  } = useSnapshot(OrgSettingsStore);
  const { logout } = useAuth0();
  const { chosenOrganization } = useOrganizations();

  const onRemove = useCallback(() => {
    deleteOrganization(logout);
  }, [logout]);

  const onClose = useCallback(() => {
    setRemoveOrgModalVisibility(false);
    setRemoveOrgVerificationValue('');
    if (!isEmpty(errorMessage)) {
      setSettingErrorMessage('');
    }
  }, [errorMessage]);

  return (
    <RemoveOrgModal
      open={isRemoveOrgModalVisible}
      onClose={onClose}
      onRemove={onRemove}
      isLoading={isLoadingRemoveOrg}
      deleteVerified={
        removeOrgVerificationValue === chosenOrganization?.display_name
      }
      deleteText={chosenOrganization?.display_name}
      errorMessage={errorMessage}
    />
  );
};

export default RemoveOrgContainer;
